import { RowQuotaDto } from "@/dtos";
import { Quota } from "@/entities";
import { getQuotaTypeLabel } from "@/helpers/options";
import { parseToCurrency, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowQuotaDto = (quotas: Quota[]): RowQuotaDto[] => {
    return quotas.map(x => {
        const row: RowQuotaDto = {
            date: parseToLocalDateTimeFromUtc(x.created_at.toString()),
            type: getQuotaTypeLabel(x.type),
            balance: '$ ' + parseToCurrency(x.before_balance).toFixed(2),
            quota: '$ ' + parseToCurrency(x.quota).toFixed(2),
            balance_result: '$ ' + parseToCurrency(x.current_balance).toFixed(2),
            administrator: x.detail.admininistrator,
            reason: x.reason
        }

        return row;
    });
}